export function SimplifyString(inputString: string | undefined): string {
    if (inputString) {
        let result = inputString.trim().toLowerCase();
        result = result.replace(/ą/g, 'a')
            .replace(/ć/g, 'c')
            .replace(/ę/g, 'e')
            .replace(/ł/g, 'l')
            .replace(/ń/g, 'n')
            .replace(/ó/g, 'o')
            .replace(/ś/g, 's')
            .replace(/ż/g, 'z')
            .replace(/ź/g, 'z')
            .replace(/ /g, '-')
            .replace(/---/g, '-')
            .replace(/,/g, '')
            .replace(/"/g, '')
            .replace(/'/g, '');
        return result;
    } else {
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/utils/String.tsx